module.exports = __webpack_public_path__ + "img/img_5.53615df9.png";